import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { AuthGuard } from "./features/auth/components/AuthGuard";
import { LoginPage } from "./features/auth/pages/LoginPage";
import { AddMentee } from "./features/coordinator/pages/AddMentee";
import { AddMentor } from "./features/coordinator/pages/AddMentor";
import { AssignmentDetails } from "./features/coordinator/pages/AssignmentDetails";
import { AssignmentsList } from "./features/coordinator/pages/AssignmentsList";
import KnowledgeManager from "./features/coordinator/pages/KnowledgeManager";
import { LandingPage } from "./features/coordinator/pages/LandingPage";
import { MeetingDetails } from "./features/coordinator/pages/MeetingDetails";
import { MenteeList } from "./features/coordinator/pages/MenteeList";
import { MentorList } from "./features/coordinator/pages/MentorList";
import { NewAssignment } from "./features/coordinator/pages/NewAssignment";
import { NewSession } from "./features/coordinator/pages/NewSession";
import RagTest from "./features/coordinator/pages/RagTest";
import { ScheduledMeetingsList } from "./features/coordinator/pages/ScheduledMeetingsList";
import { UploadDocument } from "./features/coordinator/pages/UploadDocument";
import { Layout } from "./features/shared/components/Layout";

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Public routes */}
        <Route key="login" path="/auth/login" element={<LoginPage />} />

        {/* Protected routes wrapper */}
        <Route element={<AuthGuard />}>
          <Route
            element={
              <Layout>
                <Outlet />
              </Layout>
            }
          >
            {/* Default redirect */}
            <Route index element={<Navigate to="/coordinator" replace />} />

            {/* Coordinator routes */}
            <Route path="coordinator">
              <Route index element={<LandingPage />} />
              <Route path="assignments" element={<AssignmentsList />} />
              <Route path="assignments/:id" element={<AssignmentDetails />} />
              <Route path="assignments/new" element={<NewAssignment />} />
              <Route path="mentors" element={<MentorList />} />
              <Route path="mentors/add" element={<AddMentor />} />
              <Route path="mentees" element={<MenteeList />} />
              <Route path="mentees/add" element={<AddMentee />} />
              <Route path="meetings" element={<ScheduledMeetingsList />} />
              <Route path="meetings/:uuid" element={<MeetingDetails />} />
              <Route path="meetings/new" element={<NewSession />} />
              <Route path="knowledge-manager" element={<KnowledgeManager />} />
              <Route
                path="knowledge-manager/upload"
                element={<UploadDocument />}
              />
              <Route path="knowledge-manager/rag-test" element={<RagTest />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
